module.exports = __webpack_public_path__ + "assets/events_transportation_primary.49a43eb5.svg";